import { useQuery, UseQueryOptions } from 'react-query'

import Deserializer from '~/services/Deserializer'
import EmpriseGroup from '~/services/EmpriseGroup'

import {
  BlogArticlePaginationModel,
  BlogArticleParams,
  BlogBaseArticle
} from '~/models/Blog'
import {
  ArticleListing,
  ArticleListingParams
} from '~/models/Listing/interface'

export const newsReviewConfig = {
  searchArticles: {
    key: 'searchArticles',
    request: async ({ queryKey }) => {
      const [_key, params] = queryKey

      const resp = await EmpriseGroup.getBlogArticles(params)
      const articles = await Deserializer.deserialize(resp?.articles)

      return { articles, pagy: resp?.pagy }
    }
  },
  getArticleListings: {
    key: 'getArticleListings',
    request: async ({ queryKey }) => {
      const [_key, params] = queryKey

      const resp = await EmpriseGroup.getArticleListings(params)

      return resp
    }
  }
}

interface UseGetSearchArticlesProps {
  params: BlogArticleParams
  options?: UseQueryOptions<BlogArticlePaginationModel>
}

export const useGetSearchArticles = (props?: UseGetSearchArticlesProps) => {
  const { searchArticles: config } = newsReviewConfig
  const { options, params } = props || {}
  const state = useQuery<BlogArticlePaginationModel>(
    [config.key, params],
    config.request,
    {
      initialData: {
        pagy: { page: 1, pages: 1 },
        articles: [] as BlogBaseArticle[]
      },
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      ...options
    }
  )

  return state
}

interface UseGetArticleListingsProps {
  params: ArticleListingParams
  options?: UseQueryOptions<ArticleListing[]>
}

export const useGetArticleListings = (props?: UseGetArticleListingsProps) => {
  const { options, params } = props || {}
  const { getArticleListings: config } = newsReviewConfig

  const state = useQuery<ArticleListing[]>(
    [config.key, params],
    config.request,
    { refetchOnWindowFocus: false, ...options }
  )

  return state
}
